var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("Categories", { attrs: { categoryId: _vm.$route.params.categoryId } }),
      _vm._v(" "),
      _vm.activeProduct
        ? _c("section", [
            _c("h1", [_vm._v(_vm._s(_vm.activeProduct.name))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.activeProduct.description))]),
            _vm._v(" "),
            _c("fieldset", { staticClass: "product-info" }, [
              _c("div", [
                _c("span", [_vm._v("Цена")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.activeProduct.price))]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("Размер")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.activeProduct.size))]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("Состав")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.activeProduct.composition))]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("Производитель")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.activeProduct.manufacturer))]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "product-photos" },
                  _vm._l(_vm.activeProduct.photos, function (photo, index) {
                    return _c("img", {
                      attrs: { src: "/api/public/photos/" + photo.id },
                      on: {
                        click: function ($event) {
                          return _vm.openGallery(index)
                        },
                      },
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _c("lightbox", {
                  ref: "lightbox",
                  attrs: {
                    media: _vm.prepareLightbox(),
                    "show-light-box": false,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }